import { render, staticRenderFns } from "./ComponentView.vue?vue&type=template&id=639ef45a&scoped=true"
import script from "./ComponentView.vue?vue&type=script&lang=js"
export * from "./ComponentView.vue?vue&type=script&lang=js"
import style0 from "./ComponentView.vue?vue&type=style&index=0&id=639ef45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ef45a",
  null
  
)

export default component.exports